// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h3 { text-align: center; display: grid; place-items: center; height: 100%;}`, "",{"version":3,"sources":["webpack://./src/app/oauth-callback.component.ts"],"names":[],"mappings":"AAAA,KAAK,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,YAAY,CAAC","sourcesContent":["h3 { text-align: center; display: grid; place-items: center; height: 100%;}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
